import { render } from "./match-odds-modal.vue?vue&type=template&id=02528b6e&scoped=true"
import script from "./match-odds-modal.vue?vue&type=script&lang=js"
export * from "./match-odds-modal.vue?vue&type=script&lang=js"

import "./match-odds-modal.vue?vue&type=style&index=0&id=02528b6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02528b6e"]])

export default __exports__